<div class="toaster position-fixed bottom-0 end-0 px-3 py-2">
    @for (toast of currentToasts; track toast; let i = $index) {
<!--        <app-toast-->
<!--                [type]="toast.type"-->
<!--                [title]="toast.title"-->
<!--                [message]="toast.message"-->
<!--                (disposeEvent)="dispose(i)"-->
<!--        />-->
    }
</div>
